module.exports = __webpack_public_path__ + "static/044.thumb-b87000481f388ae0b896f12ee388a5d6.jpg";